import Navigation from '../navigation/Navigation';
import { useDispatch, useSelector } from 'react-redux';
import { getStories, setIsMainPage } from '@/stores/slices/modelsState';
import { useEffect, useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useLadyService from '@/services/LadyService';
import { setVideoCallRoom } from '@/stores/slices/videoCallSlice';
import { getProfilesCount } from '@/stores/slices/mapModelSlice';
import useTitle from '@/hooks/useTitle';
import {
	getUserCurrentCity,
	getUserCurrentDistrict,
	getUserRegion,
} from '@/stores/slices/userSlice';
import { getTitle } from '@/stores/slices/titleSlice';
import { getCountrySlug } from '@/stores/slices/userSlice';
import BestCityAgencySlider from '../sliders/bestCityAgencySlider/BestCityAgencySlider';
import GirlMap from '../girlMap/GirlMap';
import AboutService from '../aboutService/AboutService';
import BenefitsBlock from '../benefitsBlock/BenefitsBlock';
import StoriesComponent from '../stories/StoriesComponent';
import Selection from '@/components/pages/selection/Selection';
import useDescription from '@/hooks/useDescription';
import BestCityMassageSlider from '../sliders/bestCityAgencySlider/BestCityMassageSlider';
import { setFilterMiniPopupStatus } from '@/stores/slices/filterPopupSlice';
import { useFilterLogicContext } from '../filter/FilterLogicProvider';
import { getProfilesOnMapCount } from '@/stores/slices/filterSlice';

const MainPage = ({ initialData }) => {
	const dispatch = useDispatch();
	const { t, userType, lang } = useLadyService();
	const FILTER = useFilterLogicContext();

	const params = useParams();
	const { room, uuid, params: thirdSegment, city } = params;

	const stories = useSelector(getStories);
	const profilesCountValue = useSelector(getProfilesCount);
	const currentCity = useSelector(getUserCurrentCity);
	const title = useSelector(getTitle);
	const region = useSelector(getUserRegion);
	const [onMap, setOnMap] = useState(0);
	const profilesOnMapCount = useSelector(getProfilesOnMapCount);
	const currentDistrict = useSelector(getUserCurrentDistrict);
	const countrySlug = useSelector(getCountrySlug);

	const defaultCountryReplacement = useMemo(() => {
		switch (lang) {
			case 'cz': {
				return 'Česko';
			}
			case 'ru': {
				return 'Чехия';
			}
			default: {
				return 'Czechia';
			}
		}
	}, [lang]);

	const isMassage = useMemo(() => {
		return FILTER.filterState.service_type.includes('massage');
	}, [FILTER.filterStateIndicator]);

	const isJsdom =
		typeof window !== 'undefined' &&
		window.navigator.userAgent.includes('jsdom');

	const titleParams = useMemo(() => {
		const countryCode = currentCity?.icon?.toLowerCase?.() || 'cz';
		let postTitle = t('titlecountry', {
			Country: currentCity?.title ?? defaultCountryReplacement,
			CountryCode: countryCode,
		});

		let postDesc = t('descriptioncountry', {
			Country: countrySlug ?? defaultCountryReplacement,
		});

		if (currentCity?.title && currentCity?.slug !== 'czechia') {
			postTitle = t('title', {
				City: currentCity.title ? currentCity.title : '',
				CountryCode: countryCode,
				Country: region,
			});
			postDesc = t('description', {
				City: currentCity.title,
				Country: region,
			});
		}

		if (currentDistrict?.name) {
			postTitle = t('titledistrict', {
				City: currentCity.title,
				District: currentDistrict.name,
			});
			postDesc = t('descdistrict', {
				City: currentCity.title,
				District: currentDistrict.name,
			});
		}
		if (thirdSegment?.includes('massage')) {
			postTitle = t('titlemassage', {
				Country: currentCity.title,
				District: currentDistrict.name,
			});
			postDesc = t('descriptionmassage', {
				Country: currentCity.title,
				District: currentDistrict.name,
			});
		}

		const titleString =
			title.length <= 0 || (title.length === 1 && title[0] === 'massage')
				? undefined
				: title
					.filter((item) => !!item)
					.map((item) => {
						if (item === 'escort') {
							return t('accompaniment');
						} else {
							return t(item);
						}
					})
					.join(', ');

		const fastFiltersTitle = titleString
			? t('fastFiltersTitle', {
				Filters: titleString,
				City: (
					currentCity.title ?? defaultCountryReplacement
				).replaceAll(' ', ''),
				District: currentDistrict?.slug
					? currentDistrict?.name
					: '',
				Country: defaultCountryReplacement,
			})
			: postTitle;

		if (titleString) {
			postDesc = t('fastFiltersDesc', {
				Filters: titleString,
				City: currentCity.title,
				District: currentDistrict?.slug ? currentDistrict?.name : '',
				Country: defaultCountryReplacement,
			});
		}

		return {
			fastFiltersTitle,
			postDesc,
		};
	}, [currentCity, currentDistrict, title, region, countrySlug, t]);

	useTitle(titleParams.fastFiltersTitle);
	useDescription(titleParams.postDesc);

	useEffect(() => {
		dispatch(setIsMainPage(true));

		return () => {
			dispatch(setIsMainPage(false));
			dispatch(setFilterMiniPopupStatus(false));

			// filter uuid
			// if (!uuid) {
			// 	FILTER.resetFilter(false);
			// }
		};
	}, []);

	useEffect(() => {
		if (room) {
			dispatch(setVideoCallRoom({ room_id: room }));
		}
	}, [dispatch, room]);

	return (
		<>
			<main className={isJsdom ? 'ssr' : ''}>
				{/* <Helmet>
					<link
						rel="alternate"
						hreflang="en"
						href={`https://lady4love.com${
							city ? '/en/' + city : ''
						}${thirdSegment ? '/' + thirdSegment : ''}`}
					/>
					<link
						rel="alternate"
						hreflang="cs"
						href={`https://lady4love.com/cz${
							city ? '/' + city : ''
						}${thirdSegment ? '/' + thirdSegment : ''}`}
					/>
					<link
						rel="alternate"
						hreflang="ru"
						href={`https://lady4love.com/ru${
							city ? '/' + city : ''
						}${thirdSegment ? '/' + thirdSegment : ''}`}
					/>
					<link
						rel="alternate"
						hreflang="x-default"
						href={`https://lady4love.com/en${
							city ? '/' + city : ''
						}${thirdSegment ? '/' + thirdSegment : ''}`}
					/>
				</Helmet> */}
				<Navigation
					mainPage={true}
					massage={initialData?.massage ?? false}
					setOnMap={setOnMap}
					onMap={onMap}
				/>
				{/*<NewGirlsSlider />*/}
				{console.log(`=> FILTER.isDataEmpty: ${FILTER.isDataEmpty}`)}
				{console.log(`=> profilesCountValue: ${profilesCountValue}`)}
				{console.log(`=> isJsdom: ${isJsdom}`)}
				{console.log(`=> onMap: ${onMap}`)}


				{((!FILTER.isDataEmpty && !!profilesCountValue) || isJsdom) &&
					profilesOnMapCount > 0 ? (
					<GirlMap />
				) : null}
				{(!isJsdom || initialData?.fastFilters === undefined) &&
					!isMassage && <BestCityAgencySlider />}
				{(!isJsdom || initialData?.fastFilters === undefined) &&
					isMassage && <BestCityMassageSlider />}
				{((isJsdom &&
					countrySlug &&
					initialData?.fastFilters === undefined) ||
					(!isJsdom &&
						countrySlug &&
						FILTER.isFilterEmpty &&
						userType === 'default')) && <AboutService />}
				{((isJsdom &&
					countrySlug &&
					initialData?.fastFilters === undefined) ||
					(!isJsdom && countrySlug)) && (
						<BenefitsBlock
							statistic={initialData?.statistics}
							showContent={FILTER.isFilterEmpty}
						/>
					)}
				{!countrySlug && <Selection isPage={false} />}
			</main>

			{!!stories.length && (
				<StoriesComponent
					favoriteButton
					descriptionText
					profileLink
					stories={stories}
				/>
			)}
		</>
	);
};

export default MainPage;
